/** Decimal degrees -> "DD°MM'SS.SS"H" string (H = N/S/E/W hemisphere letter). */
export function formatDMS(dd, isLat) {
    if (dd === null || dd === undefined || dd === '' || Number.isNaN(Number(dd))) return '';
    const value = Number(dd);
    const hemi = isLat ? (value >= 0 ? 'N' : 'S') : (value >= 0 ? 'E' : 'W');
    const abs = Math.abs(value);
    const deg = Math.floor(abs);
    const minFull = (abs - deg) * 60;
    const min = Math.floor(minFull);
    const sec = (minFull - min) * 60;
    return `${deg}°${String(min).padStart(2, '0')}'${sec.toFixed(2).padStart(5, '0')}"${hemi}`;
}
